import React, { useState } from 'react';
import styled from 'styled-components';
import SEO from '../components/SEO';
// import OptimizedImage from '../components/OptimizedImage'; // Images currently commented out
import './Spiritual.css';

const NextSectionContainer = styled.div`
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 16px;
  padding: 2rem;
  margin: 3rem auto 2rem auto;
  text-align: center;
  max-width: 600px;
  box-shadow: 0 8px 25px rgba(0,0,0,0.15);
`;

const NextSectionButton = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background: rgba(255, 255, 255, 0.2);
  color: white;
  text-decoration: none;
  padding: 1rem 2rem;
  border-radius: 50px;
  font-weight: 600;
  font-size: 1.1rem;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);

  &:hover {
    background: rgba(255, 255, 255, 0.3);
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0,0,0,0.2);
  }
`;

const Spiritual = () => {
  const [showTestimonyModal, setShowTestimonyModal] = useState(false);

  const testimonyText = `Good morning, brothers and sisters. I'm grateful to be here today and I'm grateful that I got to speak today with Noah.

A few months ago I was stuck on a song, "The Wind Beneath My Wings" by Bette Midler. And I was in the kitchen with Noah. I said, Noah, did you know that you're the wind beneath my wings? Did you know that you're my hero? And he just said, "Oh Mom, you made my day." So I did, and I continued to say, I feel like I could fly higher than an eagle. And I began to realize that he did not know the song, and I felt pretty guilty and I had to tell him.

I am grateful to have Noah as my son. He is genuinely good to the core and has the strongest desire to do it right. I know he's going to be a fantastic missionary. I just have a few things I want to talk about today.

First, I want to speak about the temple. I haven't always appreciated the temple. I had never felt things that other people would talk about after leaving the temple. I felt like maybe I wasn't good enough or I had been forgotten. And I just didn't want to go.

Then a few years ago I heard a story about my mom. My mom gave birth to a stillborn baby. I was only 5 or 6, but I remember her grief and pain and heartache. Well, not too long ago, one of my sisters told me the story about my mom. She went to the temple and she was sitting overwhelmed with grief for the loss of her baby. She felt a spirit sitting next to her comforting her. Very distinctly she knew this child's name was Eliza Jane.

Well, flash forward several years and I'm getting ready to give birth to our fourth daughter. And we had her name picked out—her name was Anna. And my mom was sitting across the table from me and she said, "What about Eliza Jane?" And I knew instantly her name was Eliza Jane. Even though I didn't know the story, I didn't know why.

And after that experience and finding that my mom was able to be comforted in the temple, I began to go to the temple and have gratitude that she was able to be comforted there. I began to think about my mom's biological dad who died when my mom was a baby. And his side of the family and worrying that his family work in the temple had not been done. I began to do research and found many families that were missing, many children that were missing, and I learned their stories. And I grew to love them.

And I began to go to the temple. And I began to feel the things that people talked about. I began to feel the spirit and the joy. And I'm so grateful for God's mercy and grace in teaching me to love the temple. And I know that he knew my struggles. And that he was aware of me.

Some of you may know that we had an extremely unique Thanksgiving. You might notice that my voice sounds similar to those old 80s or 90s commercials: "You don't always die from tobacco." Thanksgiving Day I died.

That same Eliza Jane that comforted my mom in the temple gave me CPR and saved my life. The EMTs arrived quickly and did compressions for 26 minutes and used the defibrillator 3 times before they got a faint pulse. I was rushed to the hospital and I was in the ICU for 3 days.

While I was sedated I tried to pull out my breathing tube 3 times. On the third try they tied down my hands. But I was able to sit up and pull my tube out. I know that my strong will and stubbornness does not surprise my dad. In getting that tube out, and since then I have not had a voice. I'm grateful to be alive and I don't have to haunt my husband and his new wife for the next 30 years.

President Nelson gave a talk about miracles, and he said to seek and expect miracles. I have been the recipient of many miracles in the last two weeks. If I didn't have one on Thanksgiving I probably wouldn't be here. I got up to get potatoes for Scott—which, he knows what potatoes are—but I got up and I fell on his foot. And I guess he needed a big clue that something wasn't right. Eliza had finished her third round of CPR training days before this happened.

The doctor at the hospital told me that people who went through what I had been through—only 5% survive. Months ago, I began to say a prayer that I would live long enough to raise my babies. I know I died and I know I saw my mom. And I know I was sent back. I am blown away and humbled by God's grace and mercy in allowing me to stay. I am grateful to all of you who fasted and prayed for me.

My earliest experience that I can remember about fasting happened when I was 12 or 13 years old. My brother was born with a birth defect that destroyed his kidneys. He had a strong desire to serve a mission. He was 19 years old, but he could not. He was on dialysis and he was miserable. And eventually my dad was cleared to give him a kidney.

Two days before he was to have surgery, the ward—the entire ward—fasted for him. And I remember standing in the hallway. And there was a steady huge line out the door of people coming in. And I'm looking at my brother. Overcome with tears and gratitude for the people who fasted for him.

We came into the chapel and we sat down and our family was in front. And they told us to turn around and kneel down and put our arms on the bench, and I remember turning around and seeing the whole building filled with people fasting for my brother. My brother, the next day, was good. And he checked into the hospital and he felt so good that he somehow was able to sneak back out of the hospital after being checked in and went bowling with his friends, but unfortunately, he ran into his nurse at the bowling alley who told him to go back!

He went on to serve a mission, get married and have children, and I know it's because he was blessed with many who fasted and prayed for him. I am overwhelmed with gratitude for this ward. I have been the recipient of earthly angels. I know there are many who I will never know who served me, but I am grateful.

After I woke up in the ICU I knew there was something I was trying to remember but I couldn't remember it. And I laid in bed at night and I tried to remember and I couldn't. Before I went in to do surgery to put a defibrillator in, I asked Scott for a blessing. And he said, "Use this experience to declare bold testimony of Jesus Christ, of his mercy and love." And I knew instantly that's what I was trying to remember.

And so immediately following my blessing, I texted Brother Jacob—and I'm sure he was utterly shocked—I asked him if I could speak today.

I would like to bear my testimony in closing that I know that Jesus Christ is our Savior. I know He lives, that he loves us and that he is aware of us. He knows our struggles and our heartache. He has mercy and grace. I am grateful to be a member of this ward and a member of this church. I am grateful for my calling. I love the children in this ward. I love the teachers and the leaders. I'm grateful that Noah has chosen to serve a mission.

And I say these things in the name of Jesus Christ, amen.`;

  const miracles = [
    // {
    //   title: "Maggie's Premonition",
    //   description: "A divine warning that prepared the way",
    //   content: "Before this day, Maggie had a premonition that something was going to happen. She felt a sense that change was coming, that she was being prepared for something significant. This spiritual forewarning was the first miracle—God's tender mercy in preparing her heart and soul."
    // },
    {
      title: "A Mother's Sacred Prayer",
      description: "Her primary request was granted",
      content: "Throughout the entire year of 2024, Maggie had a feeling that something was coming and had two main focuses in her prayers: first, she prayed and asked that if she died, she would be allowed to come back, and second, that no matter what happened, she would be able to raise her children. In her hour of greatest need, these heartfelt petitions became her anchor. She was given more time—precious, sacred time—to fulfill this divine calling as a mother."
    },
    // {
    //   title: "Visitors from Beyond",
    //   description: "Angels at her bedside",
    //   content: "During her journey between life and death, Maggie spoke with people on the other side of the veil. These heavenly messengers told her clearly: 'It isn't your time.' They were there to comfort, guide, and send her back to complete her earthly mission."
    // },
    {
      title: "The Pantry Providence",
      description: "A divine choreography of events",
      content: "Before the incident, Maggie got up from bed and walked into the pantry, where she eventually collapsed. She landed directly on Scott's left shoe. This wasn't random; it was to ensure that Scott would be right there and realize the severity of the situation."
    },
    {
      title: "Isaac's Presence",
      description: "Home when he was needed most",
      content: "Isaac being home to call 911 was no coincidence. His presence at that exact moment, his quick thinking to call for help, and his ability to get Eliza were all part of the plan to save his mom and unite our family."
    },
    {
      title: "Eliza's Preparation",
      description: "Recently CPR re-certified",
      content: "The miracle of Eliza being home and having just finished her third round of CPR training 6 days earlier cannot be overstated. Her recent certification was divine preparation for this exact moment when her skills would save her mother's life."
    },
    {
      title: "The Swift Response",
      description: "Angels in uniform arrive quickly",
      content: "First on the scene: EMTs (Paramedic Abby Walz, Firefighter/EMT Josh Cluff) were close and available even though it was a holiday. Their arrival within 5 to 6 minutes was miraculous timing. On Thanksgiving Day, when many would be with family, these dedicated first responders were positioned and ready to answer the call."
    },
    {
      title: "A Community of Angels",
      description: "More miracles revealed each day",
      content: "As we've become more aware, we continue to discover additional miracles that surrounded this day. Each person who helped, each moment of perfect timing, each prayer offered, all were part of a divine tapestry woven by loving hands."
    },
    // {
    //   title: "Perfect Peace Beyond the Veil",
    //   description: "Christ's overwhelming grace and mercy",
    //   content: "During her time between life and death, Maggie experienced perfect peace and was overwhelmed with gratitude for Christ's grace and mercy. When she awakened in the hospital, she immediately began crying tears of joy, speaking of the Savior's love that she had witnessed firsthand. This profound spiritual experience moved both her and Scott to tears as she shared her testimony of Christ's infinite grace, mercy."
    // }
  ];

  return (
    <div className="spiritual-container">
      <SEO 
        title="Spiritual Miracles & Faith"
        description="The miraculous spiritual experiences surrounding Maggie's survival. Divine interventions, answered prayers, and sacred encounters that transformed a family's understanding of God's grace and mercy."
        url="/spiritual"
        image="/uploads/hospital-journey/optimized/IMG_7708.jpeg"
        type="article"
      />
      <div className="spiritual-hero">
        <div className="spiritual-hero-content">
          <h1 className="spiritual-title">Christ is full of grace, mercy, and love.</h1>
          <p className="spiritual-subtitle">
            "No one can dwell in the presence of God but through the merits, mercy, and grace of the Holy Messiah" - <a href="https://www.churchofjesuschrist.org/study/scriptures/bofm/2-ne/2?lang=eng&id=p8#p8" target="_blank" rel="noopener noreferrer">2 Ne. 2:8</a>
          </p>
          <div className="spiritual-intro">
            <p>
              While medical science played a crucial role in Maggie's survival, we recognize that 
              miracles far beyond human understanding orchestrated every moment of that sacred day. 
              These are the spiritual evidences that confirm we are all in God's hands.
            </p>
          </div>
        </div>
      </div>

      <div className="spiritual-content">
        {/* Maggie's Sacred Testimony */}
        <div className="testimony-section">
          {/* <div className="testimony-header">
            <h2>Maggie's Testimony</h2>
            <p className="testimony-intro">
              In the hospital, while recovering from her miraculous survival, Maggie awoke and through tears talked about 
              the love, mercy, and grace of our Savior. Despite her extreme shyness and social anxiety, 
              she felt compelled to share her testimony. She insisted on speaking in church shortly after 
              leaving the hospital—something she had never done before. This is her powerful testimony 
              of what she experienced on the other side.
            </p>
          </div> */}
          
          <div className="audio-testimony">
            <div className="audio-container">
              <div className="audio-info">
                <h3>Maggie's Testimony</h3>
                <p>Given 1 week after Maggie's cardiac arrest in Saratoga Springs Ward, December 2024</p>
                <p className="audio-note">
                  <em>"In the hospital, she woke up and through tears began talking about the mercy and grace of our Savior. 
                  Both of us were in tears, and she asked me to call Brother Jacob in the bishopric to tell him she wanted to speak."</em>
                  <br />
                </p>
              </div>
              <div className="audio-player">
                <audio controls preload="metadata">
                  <source src="https://maggies-miracle-media-2025-ssoward.s3.amazonaws.com/audio/2025-06-23/Maggies_Talk_best_copy.m4a" type="audio/mp4" />
                  Your browser does not support the audio element.
                </audio>
                <div className="audio-download">
                  <a 
                    href="https://maggies-miracle-media-2025-ssoward.s3.amazonaws.com/audio/2025-06-23/Maggies_Talk_best_copy.m4a" 
                    download="Maggies_Talk_best_copy.m4a"
                    className="download-link testimony-text-button"
                  >
                    
                  </a>
                  <button 
                    onClick={() => setShowTestimonyModal(true)}
                    className="download-link testimony-text-button"
                  >
                    Read Text
                  </button>
                </div>
              </div>
              {/* <div className="audio-context">
                <p>
                  This testimony came from someone who normally turns down speaking requests due to 
                  social anxiety, but felt an overwhelming spiritual prompting to share what she 
                  experienced during her time between life and death. Her words carry the weight 
                  of having touched eternity.
                </p>
              </div> */}
            </div>
          </div>
        </div>

        <div className="divine-message">
          <div className="message-card">
            <h2>We Are All in God's Hands</h2>
            <p>
              Maggie believes her primary purpose for returning was to declare bold testimony
              of the grace and mercy of our 
              Savior and to raise her children. What happened on November 28, 2024, was not just 
              a medical emergency, it was a spiritual experience that demonstrated God's perfect 
              love, timing, and plan.
            </p>
            <p>
              Every detail, from the premonition to the positioning, from the preparation to the 
              presence of angels both seen and unseen, reveals a loving Heavenly Father who 
              watches over His children with perfect care.
            </p>
          </div>
        </div>

        <div className="miracles-grid">
          {miracles.map((miracle, index) => (
            <div key={index} className="miracle-card">
              <div className="miracle-icon">
                
              </div>
              <div className="miracle-content">
                <h3 className="miracle-title">{miracle.title}</h3>
                <p className="miracle-description">{miracle.description}</p>
                <div className="miracle-text">
                  <p>{miracle.content}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* <div className="divine-purpose">
          <div className="purpose-content">
            <h2>Divine Purpose Revealed</h2>
            <p>
              When Maggie first awoke, she was confused because she knew there was something 
              important she needed to remember, but she couldn't recall what it was.
            </p>
            <p>
              Before her procedure, she asked for a priesthood blessing. In that sacred moment, 
              Scott blessed Maggie that she would use this experience to declare bold testimony 
              of Christ's grace and mercy. The instant those words were spoken, she knew that 
              was what she had been trying to remember. And she felt a profound sense of peace and clarity 
              flooded through her.
            </p>
            <p>
              Through tears, she told us that was exactly what she couldn't remember—that when 
              she was on the other side, she had been told to return and declare bold testimony 
              of Christ and His grace and mercy. 
            </p>
            <div className="scripture-quote">
              <blockquote>
                "Wherefore, redemption cometh in and through the Holy Messiah; for he is full of grace and truth."
              </blockquote>
              <cite>- <a href="https://www.churchofjesuschrist.org/study/scriptures/bofm/2-ne/2?lang=eng&id=p6-note30a_p1#p6" target="_blank" rel="noopener noreferrer">2 Nephi 2:6</a></cite>
            </div>
          </div>
        </div> */}

        {/* <div className="spiritual-photos">
          <h2>Moments of Spiritual Significance</h2>
          <div className="spiritual-photo-grid">
            <div className="spiritual-photo-card">
              <OptimizedImage
                category="Hospital Journey"
                filename="IMG_7708.jpeg"
                alt="Family prayer and blessing"
                thumbnail={false}
                style={{ width: '100%', height: 'auto', borderRadius: '8px' }}
              />
              <div className="photo-caption">
                <p>Family united in prayer and faith</p>
              </div>
            </div>
            <div className="spiritual-photo-card">
              <OptimizedImage
                category="Hospital Journey"
                filename="IMG_7724.jpeg"
                alt="Healing and recovery"
                thumbnail={false}
                style={{ width: '100%', height: 'auto', borderRadius: '8px' }}
              />
              <div className="photo-caption">
                <p>Witnessing God's healing power</p>
              </div>
            </div>
            <div className="spiritual-photo-card">
              <OptimizedImage
                category="Hospital Journey"
                filename="IMG_7743.jpeg"
                alt="Gratitude and testimony"
                thumbnail={false}
                style={{ width: '100%', height: 'auto', borderRadius: '8px' }}
              />
              <div className="photo-caption">
                <p>Hearts full of gratitude and testimony</p>
              </div>
            </div>
          </div>
        </div> */}
      </div>

      {/* Testimony Modal */}
      {showTestimonyModal && (
        <div className="modal-overlay" onClick={() => setShowTestimonyModal(false)}>
          <div className="testimony-modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>Maggie's Sacred Testimony</h2>
              <p className="modal-subtitle">Given 1 week after Maggie's cardiac arrest in Saratoga Springs Ward, December 2024</p>
              <button 
                className="modal-close-button"
                onClick={() => setShowTestimonyModal(false)}
                aria-label="Close modal"
              >
                ×
              </button>
            </div>
            <div className="modal-content">
              <div className="testimony-text-content">
                {testimonyText.split('\n\n').map((paragraph, index) => (
                  <p key={index}>{paragraph}</p>
                ))}
              </div>
            </div>
            <div className="modal-footer">
              <button 
                className="modal-close-button-text"
                onClick={() => setShowTestimonyModal(false)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      <NextSectionContainer>
        {/* <NextSectionText>
          Continue reading heartfelt expressions of gratitude from the Soward family...
        </NextSectionText> */}
        <NextSectionButton href="/gratitude">
          💝 Gratitude →
        </NextSectionButton>
      </NextSectionContainer>
    </div>
  );
};

export default Spiritual;
